/* src/app/service-item/sync-dialog/sync-dialog-container/sync-dialog-container.component.scss */
:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}
ef-sync-dialog-presenter {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}
/*# sourceMappingURL=sync-dialog-container.component.css.map */
